import axios from 'axios';
import { BROWSER_STORAGE_BASE_NAME } from '../define/global';

import SDSamliphopangche_Outline from '../img/extraFont/SDSamliphopangche_Outline.png';
import SDSamliphopangche_Outline_ko from '../img/extraFont/SDSamliphopangche_Outline_ko.png';
import SDSamliphopangche_Basic from '../img/extraFont/SDSamliphopangche_Basic.png';
import SDSamliphopangche_Basic_ko from '../img/extraFont/SDSamliphopangche_Basic_ko.png';
import IBMPlexSansKR_Regular from '../img/extraFont/IBMPlexSansKR_Regular.png';
import IBMPlexSansKR_ExtraLight from '../img/extraFont/IBMPlexSansKR_ExtraLight.png';
import Cafe24Oneprettynight from '../img/extraFont/Cafe24Oneprettynight.png';
import Cafe24Oneprettynight_ko from '../img/extraFont/Cafe24Oneprettynight_ko.png';
import Cafe24Shiningstar from '../img/extraFont/Cafe24Shiningstar.png';
import Cafe24Shiningstar_ko from '../img/extraFont/Cafe24Shiningstar_ko.png';
import Cafe24Dangdanghae from '../img/extraFont/Cafe24Dangdanghae.png';
import Cafe24Dangdanghae_ko from '../img/extraFont/Cafe24Dangdanghae_ko.png';
import Cafe24Danjunghae from '../img/extraFont/Cafe24Danjunghae.png';
import Cafe24Danjunghae_ko from '../img/extraFont/Cafe24Danjunghae_ko.png';
import Cafe24Simplehae from '../img/extraFont/Cafe24Simplehae.png';
import Cafe24Simplehae_ko from '../img/extraFont/Cafe24Simplehae_ko.png';
import Cafe24Syongsyong from '../img/extraFont/Cafe24Syongsyong.png';
import Cafe24Syongsyong_ko from '../img/extraFont/Cafe24Syongsyong_ko.png';
import Cafe24Ssukssuk from '../img/extraFont/Cafe24Ssukssuk.png';
import Cafe24Ssukssuk_ko from '../img/extraFont/Cafe24Ssukssuk_ko.png';
import NanumSquareR from '../img/extraFont/NanumSquareR.png';
import NanumSquareR_ko from '../img/extraFont/NanumSquareR_ko.png';
import NanumMyeongjo_Regular from '../img/extraFont/NanumMyeongjo_Regular.png';
import NanumMyeongjo_Regular_ko from '../img/extraFont/NanumMyeongjo_Regular_ko.png';
import SlowSlow from '../img/extraFont/SlowSlow.png';
import SlowSlow_ko from '../img/extraFont/SlowSlow_ko.png';
import NanumGothic_Regular from '../img/extraFont/NanumGothic_Regular.png';
import NanumGothic_Regular_ko from '../img/extraFont/NanumGothic_Regular_ko.png';
import BMJUA from '../img/extraFont/BMJUA.png';
import BMJUA_ko from '../img/extraFont/BMJUA_ko.png';
import DungGeunMo from '../img/extraFont/DungGeunMo.png';
import DungGeunMo_ko from '../img/extraFont/DungGeunMo_ko.png';
import ROKABold from '../img/extraFont/ROKABold.png';
import ROKABold_ko from '../img/extraFont/ROKABold_ko.png';

import Batang from '../img/extraFont/Batang.png';
import Batang_ko from '../img/extraFont/Batang_ko.png';
import Dotum from '../img/extraFont/Dotum.png';
import Dotum_ko from '../img/extraFont/Dotum_ko.png';
import Gungsuh from '../img/extraFont/Gungsuh.png';
import Gungsuh_ko from '../img/extraFont/Gungsuh_ko.png';
import H2MJSM from '../img/extraFont/H2MJSM.png';
import H2MJSM_ko from '../img/extraFont/H2MJSM_ko.png';
import MalgunGothic from '../img/extraFont/MalgunGothic.png';
import MalgunGothic_ko from '../img/extraFont/MalgunGothic_ko.png';

const fontArr = [
  {
    fontFamily: 'Sandoll Samliphopangche TTF Ou',
    fontUrl:
      'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts-20-12@1.0/SDSamliphopangche_Outline.woff',
    fontThumbnail: SDSamliphopangche_Outline,
    fontThumbnailKo: SDSamliphopangche_Outline_ko
  },
  {
    fontFamily: 'Sandoll Samliphopangche TTF Ba',
    fontUrl:
      'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts-20-12@1.0/SDSamliphopangche_Basic.woff',
    fontThumbnail: SDSamliphopangche_Basic,
    fontThumbnailKo: SDSamliphopangche_Basic_ko
  },
  {
    fontFamily: 'IBM Plex Sans KR',
    fontUrl:
      'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-07@1.0/IBMPlexSansKR-Regular.woff',
    fontThumbnail: IBMPlexSansKR_Regular
  },
  {
    fontFamily: 'IBM Plex Sans KR ExtraLight',
    fontUrl:
      'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-07@1.0/IBMPlexSansKR-ExtraLight.woff',
    fontThumbnail: IBMPlexSansKR_ExtraLight
  },
  {
    fontFamily: 'Cafe24 Oneprettynight',
    fontUrl:
      'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.1/Cafe24Oneprettynight.woff',
    fontThumbnail: Cafe24Oneprettynight,
    fontThumbnailKo: Cafe24Oneprettynight_ko
  },
  {
    fontFamily: 'Cafe24 Shiningstar',
    fontUrl:
      'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.1/Cafe24Shiningstar.woff',
    fontThumbnail: Cafe24Shiningstar,
    fontThumbnailKo: Cafe24Shiningstar_ko
  },
  {
    fontFamily: 'Cafe24 Dangdanghae',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.2/Cafe24Dangdanghae.woff',
    fontThumbnail: Cafe24Dangdanghae,
    fontThumbnailKo: Cafe24Dangdanghae_ko
  },
  {
    fontFamily: 'Cafe24 Danjunghae',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.1/Cafe24Danjunghae.woff',
    fontThumbnail: Cafe24Danjunghae,
    fontThumbnailKo: Cafe24Danjunghae_ko
  },
  {
    fontFamily: 'Cafe24 Simplehae',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.1/Cafe24Simplehae.woff',
    fontThumbnail: Cafe24Simplehae,
    fontThumbnailKo: Cafe24Simplehae_ko
  },
  {
    fontFamily: 'Cafe24 Syongsyong',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.1/Cafe24Syongsyong.woff',
    fontThumbnail: Cafe24Syongsyong,
    fontThumbnailKo: Cafe24Syongsyong_ko
  },
  {
    fontFamily: 'Cafe24 Ssukssuk ',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.1/Cafe24Ssukssuk.woff',
    fontThumbnail: Cafe24Ssukssuk,
    fontThumbnailKo: Cafe24Ssukssuk_ko
  },
  {
    fontFamily: 'NanumSquare',
    fontUrl: 'https://cdn.rawgit.com/moonspam/NanumSquare/master/NanumSquareR.woff',
    fontThumbnail: NanumSquareR,
    fontThumbnailKo: NanumSquareR_ko
  },
  {
    fontFamily: 'NanumMyeongjo',
    fontUrl: 'https://cdn.jsdelivr.net/font-nanum/1.0/nanummyeongjo/v2/NanumMyeongjo-Regular.woff',
    fontThumbnail: NanumMyeongjo_Regular,
    fontThumbnailKo: NanumMyeongjo_Regular_ko
  },
  {
    fontFamily: 'Nanum NeuRisNeuRisCe',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/naverfont_10@1.0/SlowSlow.woff',
    fontThumbnail: SlowSlow,
    fontThumbnailKo: SlowSlow_ko
  },
  {
    fontFamily: 'NanumGothic',
    fontUrl: 'https://cdn.jsdelivr.net/font-nanum/1.0/nanumgothic/v3/NanumGothic-Regular.woff',
    fontThumbnail: NanumGothic_Regular,
    fontThumbnailKo: NanumGothic_Regular_ko
  },
  {
    fontFamily: 'BM JUA_TTF',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_one@1.0/BMJUA.woff',
    fontThumbnail: BMJUA,
    fontThumbnailKo: BMJUA_ko
  },
  {
    fontFamily: 'DungGeunMo',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/DungGeunMo.woff',
    fontThumbnail: DungGeunMo,
    fontThumbnailKo: DungGeunMo_ko
  },
  {
    fontFamily: 'ROKA',
    fontUrl: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2104@1.1/ROKABold.woff',
    fontThumbnail: ROKABold,
    fontThumbnailKo: ROKABold_ko
  },
  {
    fontFamily: 'Batang',
    fontUrl: '/fonts/BatangW05-Regular.woff',
    fontThumbnail: Batang,
    fontThumbnailKo: Batang_ko
  },
  {
    fontFamily: 'Gungsuh',
    fontUrl: '/fonts/GungsuhW05-Regular.woff',
    fontThumbnail: Gungsuh,
    fontThumbnailKo: Gungsuh_ko
  },
  {
    fontFamily: 'Dotum',
    fontUrl: '/fonts/DotumW05-Regular.woff',
    fontThumbnail: Dotum,
    fontThumbnailKo: Dotum_ko
  },  
  {
    fontFamily: 'HYSinMyeongJo M',
    fontUrl: '/fonts/H2MJSM.ttf',
    fontThumbnail: H2MJSM,
    fontThumbnailKo: H2MJSM_ko
  }
  // {
  //   fontFamily: 'Malgun Gothic',
  //   fontUrl: '/fonts/MalgunGothicW05-Regular.woff',
  //   fontThumbnail: MalgunGothic,
  //   fontThumbnailKo: MalgunGothic_ko
  // }
];

const BROWSER_STORAGE_KEY = `${BROWSER_STORAGE_BASE_NAME}_USE_FONTS`;

export const CHANGE_FONT_TEMP_FILE_EXT = '.tmp';

export const getUseFonts = () => {
  return window.localStorage[BROWSER_STORAGE_KEY] === 'true';
};

export const setUseFonts = (isUse) => {
  window.localStorage[BROWSER_STORAGE_KEY] = isUse;
};

async function getFontsData() {
  let promiseArr = [];

  for (let i = 0; i < fontArr.length; i++) {
    promiseArr.push(
      axios.get(fontArr[i].fontUrl, {
        responseType: 'blob',
        headers: {}
      })
    );
  }

  return Promise.allSettled(promiseArr);
}

export async function getFontsArr() {
  try {
    const response = await getFontsData();
    const fontsArr = response
      .filter((item) => item.status === 'fulfilled')
      .map((item) => {
        const fontItem = fontArr.find((font) => font.fontUrl === item.value.config.url);
        return {
          fontFamily: fontItem.fontFamily,
          fontThumbnail: fontItem.fontThumbnail,
          fontThumbnailKo: fontItem.fontThumbnailKo,
          fontBlob: item.value.data
        };
      });
    return fontsArr;
  } catch (error) {
    throw new Error(error);
  }
}
